import { AnimatePresence } from 'framer-motion'
import React, { useState } from 'react'

import { IconClose } from 'components/icons/close'

import { buildShareUrl } from './helpers'
import {
  ShareContainer,
  ButtonShareMenu,
  ButtonShare,
  ButtonClose,
  FooterMenu,
} from './styled'

import { IconFacebook } from '../icons/facebook'
import { IconRss } from '../icons/rss'
import { IconShare } from '../icons/share'
import { IconTelegram } from '../icons/telegram'
import { IconTwitter } from '../icons/twitter'
const socialLinks = [
  { icon: <IconFacebook />, url: buildShareUrl('facebook') },
  { icon: <IconTwitter />, url: buildShareUrl('twitter') },
  { icon: <IconTelegram />, url: buildShareUrl('telegram') },
  { icon: <IconRss />, url: buildShareUrl('facebook') },
]

export const Share: React.FC = () => {
  const [open, setOpen] = useState(false)

  return (
    <ShareContainer>
      <ButtonShareMenu
        onClick={() => setOpen(!open)}
        whileTap={{ scale: 0.95 }}
        transition={{ type: 'spring', stiffness: 200 }}
        style={{ opacity: open ? 0 : 1 }}
      >
        Поделиться
        <IconShare />
      </ButtonShareMenu>

      <AnimatePresence>
        {open && (
          <FooterMenu
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ type: 'spring', duration: 0.5 }}
          >
            {socialLinks.map((item, i) => (
              <ButtonShare
                key={Math.random()}
                href={item.url}
                target="_blank"
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 0.05 * i }}
              >
                {item.icon}
              </ButtonShare>
            ))}
            <ButtonClose
              onClick={() => setOpen(!open)}
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.05 * 6 }}
            >
              <IconClose />
            </ButtonClose>
          </FooterMenu>
        )}
      </AnimatePresence>
    </ShareContainer>
  )
}
